import React, { useEffect, useState } from "react";
import IC_logo from "../../../../assets/images/1744877067.jpg";
import Pagination from "../../../../pagination/components/index";
import { useDispatch, useSelector } from "react-redux";
import { getClientList } from "../slice/clientListingSlice";
import { useNavigate } from 'react-router-dom';
import "../style/clientListing-style.css";

const ClientListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clients } = useSelector((state) => state.clientList);

  useEffect(() => {
      dispatch(getClientList());
    }, [dispatch]);

  return (
    <>
    {/* <ClientHeader /> */}
      <div className="client-layout">
        <div className="client-listing">
          {clients.map((client) => (
            <div key={client.id} className="client-card">
              <div className="client-photo-wrapper">
                <a href="#">
                  <img src={IC_logo} alt={client.first_name} className="client-photo" />
                </a>
              </div>
              <div className="client-details-main">
                <div className="client-details">
                  <a className="client_name" href="#">{client.first_name}</a><br />
                  <p className="client_location">
                    <i className="fa fa-location-arrow"></i> <b>Location:</b> {client.address}
                  </p>
                  <p> Email: {client.email}</p>
                  <p><button type="button" className="btn_view_proifile">View Profile</button></p>
                  <p><button type="button" className="btn_chat" onClick={() => navigate(`/provider/chat/client/${client.id}`)}><i className="fa fa-comment px-1"></i> Chat</button></p>
                </div>
                <div className="send-request-block">
                  <button type="button" className="btn_send_request">Send Request</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
      </div>
      
    </>
  );
};

export default ClientListing;